export enum FileRecordBuzzNotification {
    Approved = 1,
    Unapproved = 2
}
